import React, { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import api from '../api/axiosConfig';
import { showSuccessToast, showErrorAlert } from '../utils/alert';
import './LoginPage.css';

const ResetPasswordPage = () => {
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { userId } = location.state || {};
  
  if (!userId) { navigate('/forgot-password'); } // Redirect jika diakses tanpa userId

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/api/users/reset-password', { userId, otp, password });
      showSuccessToast(data.message);
      navigate('/login');
    } catch (error) {
      showErrorAlert(error.response?.data?.message || 'Gagal mereset password.');
      setLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <form className="login-form-card" onSubmit={handleSubmit}>
      <div className="login-header"><h1 className="login-title">Reset Password</h1></div>
        <div className="form-group"><label>Kode OTP</label><input type="text" value={otp} onChange={(e) => setOtp(e.target.value)} required /></div>
        <div className="form-group"><label>Password Baru</label><input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /></div>
        <button type="submit" className="login-button" disabled={loading}>{loading ? 'Menyimpan...' : 'Simpan Password Baru'}</button>
        <p><Link to="/login">Kembali ke Login</Link></p>
      </form>
    </div>
  );
};
export default ResetPasswordPage;